import React from 'react';
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import BreadcrumbOne from '../../elements/breadcrumb/BreadcrumbOne';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiYoutube } from "react-icons/fi";
import { Link } from 'react-router-dom';

const iconWrapperStyle = {
    width: '120px',
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '60px',
    // color: '#fff',
    borderRadius: '50%',
    transition: '0.4s ease',
    background: 'transparent',
};

const hoverStyle = {
    background: 'linear-gradient(135deg, #6e8efb, #a777e3)',
};

const socialLinks = [
    { icon: <FiFacebook />, url: 'https://www.facebook.com/share/1754Rg7oLS/?mibextid=wwXIfr' },
    { icon: <FiYoutube />, url: 'https://youtube.com/@jahidhasan8987?si=76fx7ntr48YlvzrH' },
     { icon: <FiLinkedin />, url: 'https://www.linkedin.com/in/jahid-hasan-5932131b8' },
    // { icon: <FiInstagram />, url: 'https://instagram.com' },
    // { icon: <FiLinkedin />, url: 'https://linkedin.com' },
];
const socialLinks2 = [
    { icon: <FiFacebook />, url: 'https://www.facebook.com/share/16qKp424qd/?mibextid=wwXIfr' },
    { icon: <FiYoutube />, url: 'https://youtube.com/@passionateworld8122?si=-0yD6TMI4oaR6NJQ' },
    // { icon: <FiInstagram />, url: 'https://instagram.com' },
   
];

const Media = () => {
    return (
        <>
            <SEO title="Audit and Accelerate Your Life, Business & Income" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                <BreadcrumbOne
                    title="OUR MEDIA"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Media"
                />

                {/* Start Elements Area */}
                <div className="rwt-social-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className='text-center'>JAHID HASAN</h1>
                            </div>
                        </div>

                        <div className="row mt--30 justify-content-center">
                            <div className="col-lg-12 d-flex justify-content-center gap-4 flex-wrap">
                                {socialLinks.map((item, index) => (
                                    <a
                                        key={index}
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <div
                                            style={{ ...iconWrapperStyle }}
                                            onMouseEnter={e =>
                                                Object.assign(e.currentTarget.style, hoverStyle)
                                            }
                                            onMouseLeave={e =>
                                                Object.assign(e.currentTarget.style, { background: 'transparent' })
                                            }
                                        >
                                            {item.icon}
                                        </div>
                                    </a>
                                ))}

                            </div>
                            <div className="row">
                            <div className="col-lg-12">
                                <h1 className='text-center'>Passionate World</h1>
                            </div>
                        </div>
                             <div className="col-lg-12 d-flex justify-content-center gap-4 flex-wrap">
                                {socialLinks2.map((item, index) => (
                                    <a
                                        key={index}
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <div
                                            style={{ ...iconWrapperStyle }}
                                            onMouseEnter={e =>
                                                Object.assign(e.currentTarget.style, hoverStyle)
                                            }
                                            onMouseLeave={e =>
                                                Object.assign(e.currentTarget.style, { background: 'transparent' })
                                            }
                                        >
                                            {item.icon}
                                        </div>
                                    </a>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
                {/* End Elements Area */}

                <FooterOne />
                <Copyright />
            </main>
        </>
    );
};

export default Media;
